import { myAccountHomepageSelectorStyles } from "@insite/content-library/Widgets/MyAccount/MyAccountHomepageSelector";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

myAccountHomepageSelectorStyles.checkboxGroup = {
    css: css`
        align-items: flex-end;
        height: 100%;
        justify-content: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    align-items: flex-start;
                `,
                css`
                    align-items: flex-start;
                `,
                null,
                null,
                null,
            ],"minMax",
        )}
    `,
}